import SkeletonStyles from './Skeletons.module.css';

const ResourceFileItemSkeleton = ({ count = 1 }) => {
  return (
    <>
      {Array.from({ length: count }).map((_, index) => (
        <div key={index} className={SkeletonStyles.resource_file_skeleton}>
        </div>
      ))}
    </>
  );
};

export default ResourceFileItemSkeleton;
